var _defs, _g, _g2, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemoramaPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow-card",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 8,
    stdDeviation: 5,
    floodColor: "#000000",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradCardBack",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1E3A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0F172A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradCardFront",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD54F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E65100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "shine",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 20) rotate(-15 40 40)",
    filter: "url(#shadow-card)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 55,
    height: 75,
    rx: 8,
    fill: "url(#gradCardBack)",
    stroke: "#38BDF8",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 37.5,
    r: 15,
    fill: "none",
    stroke: "#38BDF8",
    strokeWidth: 2,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,37.5 L42.5,37.5 M27.5,22.5 L27.5,52.5",
    stroke: "#38BDF8",
    strokeWidth: 2,
    opacity: 0.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45, 25) rotate(10 40 40)",
    filter: "url(#shadow-card)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 55,
    height: 75,
    rx: 8,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 47,
    height: 67,
    rx: 5,
    fill: "none",
    stroke: "url(#gradCardFront)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 37.5,
    r: 18,
    fill: "url(#gradCardFront)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,25 L32,32 L40,32 L34,37 L36,45 L27.5,41 L19,45 L21,37 L15,32 L23,32 Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 55,
    height: 30,
    rx: 8,
    fill: "url(#shine)",
    clipPath: "inset(0 0 0 0 round 8px)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 90,
    r: 3,
    fill: "#FFD54F",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 30,
    r: 2,
    fill: "#38BDF8",
    opacity: 0.9
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 100,
    r: 4,
    fill: "#FFD54F",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoramaPremium);
export default __webpack_public_path__ + "static/media/memorama_premium.878af402554e8025d340787d6f9958f5.svg";
export { ForwardRef as ReactComponent };